import { useMemo } from 'react';

import { useAppSelector } from '@src/core/hooks';
import {
  getOrderCoupon,
  getOrderSaleChangesAmount,
  getOrderServiceFeeDescriptions,
  type Order,
} from '@src/domains/orders';
import { orderVoucherInfoSelector } from '@src/features/orders/store/order';

export function useOrderDetailsHeader(order: Order) {
  const { hasMultipleVouchers, hasPendingVouchers } = useAppSelector(orderVoucherInfoSelector(order.id));

  const coupon = useMemo(() => getOrderCoupon(order), [order]);
  const saleChangeAmounts = useMemo(() => getOrderSaleChangesAmount(order), [order]);
  const serviceFeeDescription = useMemo(() => getOrderServiceFeeDescriptions(order).join(', ') || undefined, [order]);

  return { coupon, saleChangeAmounts, serviceFeeDescription, hasPendingVouchers, hasMultipleVouchers };
}
